<script setup>
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
import { ref, watch, provide, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { getProfile } from '@/api/user'
import { isMobile } from '@/utils/index';
import { getWxJumpUrl } from '@/api/user'
const route = useRoute()
const isDarkTheme = ref(false)
const isWhiteHeaderBg = ref(false)
const currentPath = ref('')
const userInfo = ref()
const routeRef = ref(null)

// 更新主题的函数
const updateTheme = (isDark) => {
  isDarkTheme.value = isDark
}
// 更新header背景颜色的函数
const updateHeaderBg = (isWhite) => {
  isWhiteHeaderBg.value = isWhite
}

// 提供给子组件使用
provide('updateTheme', updateTheme)
provide('updateHeaderBg', updateHeaderBg)

// 监听路由变化
watch(
  () => route.path,
  (newPath) => {
    // 检查路由路径是否为 /lastpage
    isDarkTheme.value = !['/price', '/about', '/pay-mobile', '/login', '/service-terms', '/privacy-policy', '/register-login', '/reset-password'].includes(newPath)
    currentPath.value = newPath

    let user = localStorage.getItem('user-info');
    if (user) {
      userInfo.value = JSON.parse(user)
    }

  },
  { immediate: true } // 立即执行一次，确保初始状态正确
)

function handleFooterAction() {
  // 直接调用当前路由组件暴露的方法
  // routeRef.value?.handleQrcodeBooking?.()
  console.log('goToWorkbench...', routeRef.value);

  routeRef.value?.goToWorkbench?.()
}


onMounted(() => {
  if (localStorage.getItem('access_token')) {
    getProfile().then(res => {
      if (res.code === 200) {
        localStorage.setItem('user-info', JSON.stringify(res.data.user));
        userInfo.value = res.data.user;
      }
    });
  }
})

</script>

<template>
  <div class="app-container">
    <Header :isDarkTheme="isDarkTheme" :isWhiteHeaderBg="isWhiteHeaderBg"
      v-if="!['/login', '/service-terms', '/privacy-policy'].includes(currentPath) || isMobile()" :data="userInfo" />

    <main>
      <!-- 路由视图 -->
      <router-view v-slot="{ Component, route }">
        <keep-alive :include="['PayMobile']">
          <component :is="Component" ref="routeRef" />
        </keep-alive>
      </router-view>
    </main>
 
    <Footer
      v-if="!['/login', '/service-terms', '/privacy-policy','/about', '/register-login', '/reset-password','/member-mobile'].includes(currentPath)"
      :is-full="!['/price'].includes(currentPath)" :show-bookinng="!['/pay-mobile'].includes(currentPath)"
      @on-show-booking-dialog="handleFooterAction"/>
  </div>
</template>

<style scoped>
.app-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  /* max-width: 100vw;
  overflow-x: hidden; */
}

main {
  flex: 1;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .app-container {
    /* display: flex;
  flex-direction: column;
  min-height: 100vh; */
    max-width: 100vw;
    overflow-x: hidden;
  }
}
</style>
